import React from 'react';
import { Quote } from 'lucide-react';
import { TESTIMONIALS } from '@/data/testimonials';

export default function TestimonialGrid() {
  return (
    <section className="bg-[#0B0B0B] py-16 lg:py-20">
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {TESTIMONIALS.map((t) => (
          <figure key={t.quote} className="rounded-2xl border border-white/10 bg-white/[0.03] p-7 flex flex-col hover:border-[#3B82F6]/50 transition-colors">
            <Quote className="w-6 h-6 text-[#3B82F6]" />
            <blockquote className="mt-5 text-white/80 leading-relaxed flex-1">“{t.quote}”</blockquote>
            <figcaption className="mt-6 pt-5 border-t border-white/10">
              <p className="font-display font-semibold text-white text-sm">{t.name}</p>
              <p className="text-xs text-white/45 mt-0.5">{t.company}</p>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}